<div class="page-wrapper">
  <a
    class="back-arrow-inner"
    style="cursor: pointer"
    (click)="navigateBackToMemberSearch()"
    ><mat-icon matListIcon>arrow_back</mat-icon> Member Search</a
  >
  <div class="page-header">
    <h2>Update Coverage</h2>
  </div>
  @if (selectedMemberDetails$ | async; as selectedMemberDetails) {
    <div class="detail-card">
      <div class="client-id-name">
        <h4>Member</h4>
        <span
          >(Client: {{ selectedMemberDetails.clientId }}-{{
            selectedMemberDetails.client_full_name
          }})</span
        >
      </div>
      <div class="mat-row">
        <div class="mat-2">
          <label class="card-label">Name</label>
          <p>
            {{ selectedMemberDetails.firstName }}
            {{ selectedMemberDetails.lastName }}
          </p>
        </div>
        <div class="mat-2">
          <label class="card-label">Person Code</label>
          <p>{{ selectedMemberDetails.personCode }}</p>
        </div>
        <div class="mat-2">
          <label class="card-label">DOB</label>
          <p>{{ selectedMemberDetails.DOB | timeStampToDate }}</p>
        </div>
        <div class="mat-2">
          <label class="card-label">Relationship</label>
          <p>
            {{ selectedMemberDetails.relationshipCode }} -
            {{ relationShip[selectedMemberDetails.relationshipCode] }}
          </p>
        </div>
        <div class="mat-2">
          <label class="card-label">Card/Alt ID</label>
          <p>{{ selectedMemberDetails.cardId }}</p>
        </div>
        <div class="mat-2">
          <label class="card-label">Coverage Type</label>
          <p>
            {{
              displayCoverageType[selectedMemberDetails?.coverage?.coverageType]
            }}
          </p>
        </div>
      </div>
    </div>
    <div class="custom-tab mat-custom-tab">
      <mat-tab-group animationDuration="0ms">
        <mat-tab label="Update Coverage">
          <div fxLayoutAlign="end end" class="mt-3">
            @if (
              selectedTab === "active" &&
              !(
                !!cardHoldersCurrentCoverage &&
                cardHoldersCurrentCoverage.isSoftDeleted
              )
            ) {
              <button
                mat-stroked-button
                rounded
                color="accent"
                (click)="addNewCoverage('addCoverage')"
                class="no-border-btn"
                [disabled]="
                  isActiveCoverage ||
                  coverage?.length === 0 ||
                  (datasource?.data?.length === 0 &&
                    !!cardHoldersFutureCoverage &&
                    selectedTab === 'active')
                "
              >
                Add New Coverage
              </button>
            }
            @if (
              selectedTab === "future" &&
              (memberDetails.relationshipCode === cardHolderRC ||
                (cardHoldersFutureCoverage &&
                  memberDetails.relationshipCode !== cardHolderRC))
            ) {
              <button
                mat-stroked-button
                rounded
                color="accent"
                (click)="addNewCoverage('addFutureCoverage')"
                class="no-border-btn"
                [disabled]="hasFutureCoverage() || hasInfiniteCoverage()"
              >
                Add New Coverage
              </button>
            }
          </div>
          <div class="table-filter mb-2">
            <div class="filter">
              <div role="radiogroup" class="custom-radio">
                <p>
                  <input
                    type="radio"
                    id="coverage-active"
                    name="coverage-filter"
                    [checked]="selectedTab === 'active'"
                    (change)="onTabClick('active')"
                  />
                  <label for="coverage-active">Active</label>
                </p>
                <p>
                  <input
                    type="radio"
                    id="coverage-future"
                    name="coverage-filter"
                    [checked]="selectedTab === 'future'"
                    (change)="onTabClick('future')"
                  />
                  <label for="coverage-future">Future</label>
                </p>
                <p>
                  <input
                    type="radio"
                    id="coverage-all"
                    name="coverage-filter"
                    [checked]="selectedTab === 'all'"
                    (change)="onTabClick('all')"
                  />
                  <label for="coverage-all">All</label>
                </p>
              </div>
            </div>
            @let isActiveTab = selectedTab === "active";
            @let isFutureTab = selectedTab === "future";
            @let hasData = dataSource?.data?.length > 0;
            @let noData = dataSource?.data?.length === 0;

            @if (isActiveTab && isActiveCoverage && hasData) {
              <div class="active-member">
                <p>Only one active coverage can exist at a time.</p>
              </div>
            }

            @if (isActiveTab && noData && hasFutureEligibleCoverage() && !hasFutureCoverage()) {
              <div class="active-member">
                <p>
                  Member has coverage starting soon. Please modify the coverage
                  in the future tab.
                </p>
              </div>
            }

             @if (isActiveTab && noData && hasFutureEligibleCoverage() && hasFutureCoverage()) {
              <div class="active-member">
                <p>
                 Member already has the maximum number of coverage timelines. Please modify the upcoming coverage in the future tab.
                </p>
              </div>
            }

            @if (isFutureTab) {
              @if (hasInfiniteCoverage()) {
                <div class="active-member">
                  <p>
                    New future coverage cannot be added because the cardholder
                    already has coverage with no defined end date (valid
                    until 12/31/9999)
                  </p>
                </div>
              } @else if (hasFutureCoverage() || (hasFutureEligibleCoverage() && hasFutureCoverage())) {
                <div class="active-member">
                  <p>
                    Member already has the maximum number of coverage timelines.
                  </p>
                </div>
              }
            }
          </div>
          @if (coverageDetails$ | async; as coverage) {
            <div class="update-table">
              <table
                mat-table
                [dataSource]="dataSource"
                multiTemplateDataRows
                class="mat-elevation-z8"
              >
                <ng-container matColumnDef="group">
                  <th mat-header-cell *matHeaderCellDef>Group</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.groupId }}: {{ element.groupName }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="client">
                  <th mat-header-cell *matHeaderCellDef>Client</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.clientName }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="effectiveDate">
                  <th mat-header-cell *matHeaderCellDef>Effective Date</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.startDate | timeStampToDate }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="endDate">
                  <th mat-header-cell *matHeaderCellDef>End Date</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.endDate | timeStampToDate }}
                  </td>
                </ng-container>
                @if (selectedTab === "all") {
                  <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef>Status</th>
                    <td mat-cell *matCellDef="let element">
                      <div class="coverage-status">
                        <span
                          class="{{
                            displayCoverageStatus[element.eligibilityIndicator]
                              ?.class
                          }}"
                        ></span>
                        {{
                          displayCoverageStatus[element.eligibilityIndicator]
                            ?.name
                        }}
                      </div>
                    </td>
                  </ng-container>
                }
                <ng-container matColumnDef="edit">
                  <th mat-header-cell *matHeaderCellDef>Actions</th>
                  <td mat-cell *matCellDef="let element">
                    @if (
                      element.eligibilityIndicator === "C" &&
                      !(
                        !!cardHoldersCurrentCoverage &&
                        cardHoldersCurrentCoverage.isSoftDeleted
                      )
                    ) {
                      <mat-icon
                        class="tr-btn-icon"
                        matListIcon
                        (click)="updateCoverage('updateCoverage', element)"
                        >edit</mat-icon
                      >
                    }
                    @if (element.eligibilityIndicator === "F") {
                      <mat-icon
                        class="tr-btn-icon"
                        matListIcon
                        (click)="
                          updateCoverage('updateFutureCoverage', element)
                        "
                        >edit</mat-icon
                      >
                    }
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr
                  mat-row
                  *matRowDef="let element; columns: displayedColumns"
                  class="example-element-row"
                  [class.example-expanded-row]="expandedElement === element"
                ></tr>
                <tr class="mat-row no-data-row" *matNoDataRow>
                  <td class="mat-cell" colspan="9" role="status">
                    {{
                      selectedTab === "future"
                        ? "No Future Coverage Types Found"
                        : "No Data Found"
                    }}
                  </td>
                </tr>
              </table>
            </div>
          }
        </mat-tab>
        @if (availableFlexTag?.length) {
          <mat-tab label="Add/Update Coverage Type">
            <div class="mat-12">
              <div fxLayoutAlign="end end" class="pad-1">
                <button
                  mat-stroked-button
                  rounded
                  color="accent"
                  (click)="addNewCoverage('addRx')"
                  class="no-border-btn"
                >
                  Add Coverage Type
                </button>
              </div>
            </div>
            <!-- <p fxLayoutAlign="end end" *ngIf="!allDatesInThePast(allEndDatesArray)">
                  Only one active member benefit can exist at a time.
                </p> -->
            @if (memberRxDetails$ | async; as memberRxDetails) {
              <div class="update-table">
                <table
                  mat-table
                  [dataSource]="dataSourceRx"
                  multiTemplateDataRows
                  class="mat-elevation-z8"
                >
                  <ng-container matColumnDef="memberRxType">
                    <th mat-header-cell *matHeaderCellDef>Coverage Type</th>
                    <td mat-cell *matCellDef="let element">
                      {{ coverageTypes[element.flexTagName] }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="effectiveDate">
                    <th mat-header-cell *matHeaderCellDef>Effective Date</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.flexTagStartDate | timeStampToDate }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="endDate">
                    <th mat-header-cell *matHeaderCellDef>End Date</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.flexTagEndDate | timeStampToDate }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="edit">
                    <th mat-header-cell *matHeaderCellDef>Actions</th>
                    <td mat-cell *matCellDef="let element">
                      @if (element.active === "True") {
                        <mat-icon
                          class="tr-btn-icon"
                          matListIcon
                          (click)="updateCoverage('updateRx', element)"
                          >edit</mat-icon
                        >
                      }
                    </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="displayedColumnsRx"></tr>
                  <tr
                    mat-row
                    *matRowDef="let element; columns: displayedColumnsRx"
                    class="example-element-row"
                    [class.example-expanded-row]="expandedElement === element"
                  ></tr>
                  <tr class="mat-row no-data-row" *matNoDataRow>
                    <td class="mat-cell" colspan="9" role="status">
                      No Data Found
                    </td>
                  </tr>
                </table>
              </div>
            }
          </mat-tab>
        }
      </mat-tab-group>
    </div>
  }
</div>
